import { SocialMediaLinksBase } from "./SocialMediaLinksBase/SocialMediaLinksBase";

export default function SocialMediaLinksEditPage() {
  return <SocialMediaLinksBase isEdit={true} />;
}
